import { SeamlessApiClient } from "@mondaydotcomorg/api";

const mondayApi = new SeamlessApiClient();
const unwrapResponse = (response) =>
  response?.data?.data ?? response?.data ?? response;

const executeGraphQl = async (query, variables) => {
  try {
    const response = await mondayApi.request(query, variables);
    const data = unwrapResponse(response);
    if (!data) {
      throw new Error("The monday.com API returned no data.");
    }

    return data;
  } catch (error) {
    console.error("monday.com API request failed.", error);
    throw error;
  }
};

export const getItem = async (itemId) => {
  const response = await executeGraphQl(`
    query {
      items (ids: [${itemId}]) {
        id
        name
        column_values {
          id
          value
          type
          text
          column {
            id
            title
          }
        }
      }
    }
  `);

  return response.items[0];
};

export const updateColumnValue = async (boardId, itemId, columnId, value) => {
  if (!boardId || !itemId || !columnId) {
    throw new Error("Missing required parameters to update column value.");
  }

  let values = {
    [columnId]: value
  };

  let valuesQuery = "{";

  for (var prop in values) {
    let value = JSON.stringify(JSON.stringify(values[prop]));
    value = value.substring(3, value.length-3)

    if(valuesQuery.length > 2) {
      valuesQuery+= ", ";
    }
    valuesQuery += `\\\"${prop}\\\" : \\\"${value}\\\"`;
  }

  valuesQuery+= "}";

  const response = await executeGraphQl(`
    mutation change_column_values($boardId: ID!, $itemId: ID!) {
      change_multiple_column_values(board_id: $boardId, item_id: $itemId, column_values: "${valuesQuery}") {
        id
      }
    }
  `, { boardId, itemId });

  return response.change_simple_column_value;
};
